// extracted by mini-css-extract-plugin
module.exports = {"ProductPreview":"ProductPreview_ProductPreview__1Pquq"};